import gql from 'graphql-tag'
export default gql`
  query ElDefaults {
    ElDefaults @client {
      ElUses @client
      Defaults @client {
        itemType
        DefaultIncludes @client {
          key
          weight
        }
      }
    }
  }
`
